export const ensureArray = (a: string | string[]) => (Array.isArray(a) ? a : [a])
